// src/language/homeLanguage.js
const homeLanguage = {
  en: {
    appTitle: 'Milk Billing',
    saveButton: 'Save',
    searchCustomersPlaceholder: 'Search customers...',
    today: 'Today',
    yesterday: 'Yesterday',
    customDate: 'Custom Date',
    dailyEntriesFor: 'Daily Entries for',
    defaultLabel: 'Default',
    milkTypeCow: 'Cow',
    milkTypeBuffalo: 'Buffalo',
    literUnit: 'L',
  },
  mr: {
    appTitle: 'दूध बिलिंग',
    saveButton: 'सेव्ह करा',
    searchCustomersPlaceholder: 'ग्राहक शोधा...',
    today: 'आज',
    yesterday: 'काल',
    customDate: 'हवी ती तारीख',
    dailyEntriesFor: 'दैनंदिन नोंदी -',
    defaultLabel: 'डीफॉल्ट',
    milkTypeCow: 'गायीचे',
    milkTypeBuffalo: 'म्हशीचे',
    literUnit: ' लिटर',
  },
};

export default homeLanguage;
